import { Helmet } from "react-helmet";
import { LuMenu } from "react-icons/lu";
import { useIsUserSignedIn } from "../../core_stores/useAuthStore";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import {
  SideMenuBehavior,
  useIsSideMenuOpen,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../view_stores/useSideMenuStore";
import SideMenuPanel from "../sideMenu/SideMenuPanel";
import { WelcomeAppBar } from "../welcome/components/WelcomeAppBar";
import { WelcomeFooter } from "../welcome/components/WelcomeFooter";
import { colors } from "../../design/tokens";
import privacyPolicyContent from "../../assets/privacy_policy.md?raw";
import { MarkdownContent } from "../common_components/MarkdownContent";

export function PrivacyPolicyPage() {
  const isUserSignedIn = useIsUserSignedIn();
  const isCompactView = useIsCompactView();
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();
  const sideMenuBehavior = useSideMenuBehavior();

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Darvin - AI-Powered Mobile App Builder</title>
        <meta
          name="description"
          content="Read Darvin's privacy policy to understand how we collect, use, and protect your data when using our AI-powered mobile app builder."
        />
        <meta property="og:title" content="Privacy Policy | Darvin" />
        <meta
          property="og:description"
          content="Darvin's privacy policy - Learn how we protect your data."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://darvin.dev/privacy-policy" />
      </Helmet>

      <div className="min-h-screen flex">
        {isUserSignedIn && !isCompactView && <SideMenuPanel />}
        <div
          className={`${
            isUserSignedIn &&
            !isCompactView &&
            (sideMenuBehavior === SideMenuBehavior.PINNED
              ? "pl-[320px]"
              : "pl-[56px]")
          } flex-1 flex flex-col transition-[padding] duration-300 relative`}
        >
          {/* Header with gradient background */}
          <div className="flex flex-col relative bg-gradient-hero-dark">
            <div className="flex flex-row items-center w-full relative z-10">
              {isUserSignedIn && isCompactView && (
                <div className="pl-4">
                  <LuMenu
                    size={34}
                    onClick={isSideMenuOpen ? closeSideMenu : openSideMenu}
                    className="cursor-pointer text-white"
                  />
                </div>
              )}
              <WelcomeAppBar />
            </div>

            <div className="flex justify-center items-center px-8 pt-8 pb-16 md:pb-20 relative z-10">
              <div className="w-full max-w-[1300px] text-center">
                <h1 className="text-[42px] lg:text-[48px] font-bold text-white mb-4">
                  Privacy Policy
                </h1>
                <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-4xl mx-auto">
                  Learn how we collect, use, and protect your information
                </p>
              </div>
            </div>

            {/* Fade transition overlay */}
            <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none bg-gradient-to-b from-transparent via-dark-surface-primary/60 to-dark-surface-primary z-10" />
          </div>

          {/* Privacy Policy Content */}
          <div className={`flex-1 flex flex-col ${colors.surface.primary} px-8`}>
            <div className="w-full max-w-[680px] mx-auto pt-4 pb-16 md:pt-6 md:pb-24">
              <MarkdownContent content={privacyPolicyContent} />
            </div>
          </div>

          <WelcomeFooter />
        </div>
      </div>
    </>
  );
}
